import { render, staticRenderFns } from "./VacanciesTab.vue?vue&type=template&id=28cbb12b&scoped=true"
import script from "./VacanciesTab.vue?vue&type=script&lang=js"
export * from "./VacanciesTab.vue?vue&type=script&lang=js"
import style0 from "./VacanciesTab.vue?vue&type=style&index=0&id=28cbb12b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cbb12b",
  null
  
)

export default component.exports